module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "imger"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('el-form', {
    ref: "loginForm",
    staticClass: "demo-ruleForm login-container",
    attrs: {
      "model": _vm.loginForm,
      "rules": _vm.rules2,
      "label-position": "left",
      "label-width": "0px"
    }
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("用户登录")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "phone"
    }
  }, [_c('span', {
    staticClass: "iconfont icon-dianhua"
  }), _vm._v(" "), _c('el-input', {
    staticClass: "phone",
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "手机号码"
    },
    model: {
      value: (_vm.loginForm.phone),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "phone", $$v)
      },
      expression: "loginForm.phone"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "10px",
      "width": "100%"
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('span', {
    staticClass: "iconfont icon-mima"
  }), _vm._v(" "), _c('el-input', {
    staticClass: "phone",
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "密码"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleSubmit2.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.loginForm.password),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "password", $$v)
      },
      expression: "loginForm.password"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "20px",
      "width": "100%"
    }
  }), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%",
      "margin-bottom": "0px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.logining
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit2.apply(null, arguments)
      }
    }
  }, [_vm._v("登录")])], 1), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/register'
      }
    }
  }, [_vm._v("免费注册")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        path: '/forget'
      }
    }
  }, [_vm._v("忘记密码")])], 1)], 1)], 1), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logoBar"
  }, [_c('h1'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.jsdnn.com/",
      "target": "_blank"
    }
  }, [_vm._v("狄诺尼官网")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ftBox"
  }, [_c('p', [_vm._v("江苏狄诺尼信息技术有限责任公司")]), _vm._v(" "), _c('p', [_vm._v("CopyRight © 2019 Jiangsu Delauney Information Co., Ltd. 苏ICP备18062906")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-83e7217a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Login.vue
// module id = 1816
// module chunks = 9